// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar-module--navbar--93yzs","mainLogo":"navbar-module--mainLogo--i0TRU"};